import React, { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select, Option } from 'carbon-react/lib/components/select';
import Textbox from 'carbon-react/lib/components/textbox';

import { UICarbonNumberField } from '@futrli/ui-components';

import styles from './single-payment.scss';

interface SinglePaymentProps {
  onPaymentTermsChange: (value: string) => void;
  paymentTerms: string;
}

export const SinglePayment = ({ onPaymentTermsChange, paymentTerms }: SinglePaymentProps) => {
  const intl = useIntl();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  const onSelectPeriodChange = useCallback(() => {}, []);

  return (
    <div className={styles.singlePaymentTreatment}>
      <div>
        <FormattedMessage id="common.in_number_of_days_weeks_months_years" defaultMessage="In" />
      </div>
      <UICarbonNumberField
        className={styles.smallInput}
        autoComplete="off"
        type="number"
        onChange={onPaymentTermsChange}
        id="single-payment-term"
        name="single-payment-term"
        value={paymentTerms}
        clampMin={0}
        maxDecimals={0}
        size="large"
        mb={0}
      />
      <div className={styles.disabledCarbonPeriodSelect}>
        <Select
          autoComplete="off"
          className={styles.formInput}
          onChange={onSelectPeriodChange}
          value="days"
          disabled
          size="large"
          aria-label={intl.formatMessage({
            id: 'predict.select_period',
            defaultMessage: 'Select period'
          })}
          mb={0}
        >
          <Option value="months" text={intl.formatMessage({ id: 'common.months', defaultMessage: 'months' })} />
          <Option value="years" text={intl.formatMessage({ id: 'common.years', defaultMessage: 'years' })} />
          <Option value="days" text={intl.formatMessage({ id: 'common.days', defaultMessage: 'days' })} />
        </Select>
      </div>
      <div className={styles.disabledCarbonPercentage}>
        <Textbox
          // value={endsAfter}
          // onChange={handleEndsAfterChange}
          aria-label={intl.formatMessage({
            id: 'common.enter_percentage.aria_label',
            defaultMessage: 'Enter percentage'
          })}
          value="100"
          onChange={() => undefined}
          disabled
          size="large"
          mb={0}
        />
      </div>
      <div>{'%'}</div>
    </div>
  );
};
